import React, { useState, useEffect } from 'react'
import { withFormik, Form, Field } from 'formik'
import { Link } from 'react-router-dom'
import InfoBox from './InfoBox'
import { selfRegister } from '../utils/authService';
import { withTranslation } from 'react-i18next';

const RegistrationSuccessfulComponent = (props) => {
  const {
    values,
    history,
    t
  } = props

  useEffect(() => {
    document.title = `City of Seattle | ${t('registrationSuccessTitle')}`
  })

  // let email = history.location.state.email || '';

  return (
    <div>
      {/* <h2>{t('registrationSuccessTitle')}</h2>
      <div>{t('registrationSuccess', { email })}</div> */}
      <div className="return-link">
        <Link to='/login'>{t('returnLogin')}</Link>
      </div>
    </div>
  )
}

const RegistrationSuccessful = withFormik({
  handleSubmit(values, { props, resetForm, setSubmitting }){
  }
})(RegistrationSuccessfulComponent)

export default withTranslation()(RegistrationSuccessful);
